import React, { useEffect, useState } from "react";
import AxiosService from "../../../Utils/AxiosService";
import { toast } from "react-toastify";
import FieldCouterHeader from "./FieldCouterHeader";

const FieldCounterReport = ({ label, refreshKey, sectionRef }) => {
  const apiService = new AxiosService();
  const headers = FieldCouterHeader();
  const [nodes, setNodes] = useState([]);

  useEffect(() => {
    apiService
      .getFieldCountByLabel(label)
      .then((response) => {
        if (response.data) {
          const finalResult = response.data;
          const orderedData = headers.map((key) => ({
            key,
            value: finalResult[key] ?? 0,
          }));
          console.log(orderedData);
          setNodes(orderedData);
        }
      })
      .catch((error) => {
        if (error?.response?.data?.message) {
          toast.error(error.response.data.message);
        } else {
          toast.error("Something went wrong!");
        }
      });
  }, [label, refreshKey]);

  function convertCamelCaseToSentence(str) {
    return (
      str
        // Insert space before each uppercase letter
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        // Capitalize the first letter of the sentence
        .replace(/^./, (match) => match.toUpperCase())
    );
  }

  return (
    <div className="card  mb-3">
      <h5 className="card-header ">Field Count Report</h5>

      <div ref={sectionRef} className="card-body ">
        <div
          className="table-responsive"
          style={{ width: "50%", margin: "0 auto" }}
        >
          <table className="table table-bordered">
            <thead>
              <tr>
                <th scope="col">Field</th>
                <th scope="col">Count</th>
              </tr>
            </thead>
            <tbody>
              {nodes.map((item) => (
                <tr key={item.key}>
                  <td scope="row">
                    {item.key === "totalCount" ? (
                      <strong>{convertCamelCaseToSentence(item.key)}</strong>
                    ) : (
                      convertCamelCaseToSentence(item.key)
                    )}
                  </td>
                  <td scope="row">
                    {item.key === "totalCount" ? (
                      <strong>{item.value}</strong>
                    ) : (
                      item.value
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default FieldCounterReport;
